import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c4288ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "オペレーション情報", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "日時", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "オペレーター名", -1))

import { computed, ComputedRef } from 'vue'
  import dayjs, { Dayjs } from 'dayjs'
  import { format_time } from '@/utils/FormatTime'

  interface Props {
    started_at: string;
    call_time: number
    user_name: string;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    started_at: { type: String, required: true },
    call_time: { type: Number, required: true },
    user_name: { type: String, required: true }
  },
  setup(__props: any) {

const props = __props as {
    started_at: string;
    call_time: number
    user_name: string;
  }
  

  const started_at: ComputedRef<Dayjs> = computed(()=> dayjs(props.started_at) );

  const format: string = 'YYYY/M/D HH:mm:ss';
  const formatted_started_at: ComputedRef<string> = computed(() => started_at.value.format(format) );
  const formatted_ended_at: ComputedRef<string>   = computed(() => started_at.value.add(props.call_time, 'second').format(format) );
  const formatted_call_time: ComputedRef<string>  = computed(() => format_time(props.call_time) );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("table", null, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _hoisted_2,
          _createElementVNode("td", null, _toDisplayString(_unref(formatted_started_at)) + "〜" + _toDisplayString(_unref(formatted_ended_at)) + " (" + _toDisplayString(_unref(formatted_call_time)) + ") IN", 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_3,
          _createElementVNode("td", null, _toDisplayString(__props.user_name), 1)
        ])
      ])
    ])
  ]))
}
}

})